import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useEffect, useRef} from "react";
import {SUMMARY_DEFAULT} from "../../actions/path";
import myCharacterImg from "../../assets/my-character.jpg"
import Summary from "./index";

const SelfIntroduction = ({allMode = false}) => {

    // 페이지 이동하려면 사용해야 되는
    const currentPathSelector = useSelector(state => state.pathReducers.currentPath);
    const dispatch
        = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        navigate(currentPathSelector);
    }, [currentPathSelector]);
    // ---------------------------------

    const goToSummartDefault = (e) => {
        e.preventDefault();
        dispatch({type: SUMMARY_DEFAULT});
    }

    const selfInfoInfo = {
        imagePath:'',
        content:'<div class="selfIntro-main-content"><h2><p>[<span class="fade-item delay-3">팀원</span>] 그리고 ' +
            '[<span class="fade-item delay-7">코드</span>]에 </p>' +
            ' <p class="center-align">100퍼센트 <span class="font-purple-highlight">융화</span>되는 개발자 </p>' +
            '<p class="right-align">[<span class="fade-item delay-10">이준복</span>] 입니다.</p></h2>' +
            '</div>' +
            '<div class="selfIntro-sub-content">' +
            '<p class="lead">「 맡은 업무를 끝까지 책임감 있게 완수하는 데 확고한 자신감을 가지고 있습니다. 」</p>' +
            '<p class="lead">팀원과의 소통과 협력을 중요하게 생각하며, ' +
            '누구보다 지지않을 열정을 가지고 있습니다.</p>' +
            '<p class="lead">체계적으로 분석하는 것을 좋아하며, 적극적인 소통을 통한 효율적인 업무를 지향합니다.</p>' +
            '<p class="lead"> # 매 순간 성장하고 발전하는 개발자 💪 </p>' +
            '<p class="lead"> 상사에게는 신뢰받고 팀원에게는 지지를 받으며,' +
            ' 후배에게는 훌륭한 사수가 되는 개발자로 미래를 나아가겠습니다.</p>' +
            '</div>',
    }

    const activeTarget = 'choice-summary-1';
    const focusRef = useRef();
    useEffect(() => {
        if (allMode) return;
        document.querySelector(`#${activeTarget}`)?.classList?.add('border-primary');
        focusRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    },[])

    return (
        <>
            {!allMode && (
                <Summary/>
            )}
            <div className='container' ref={focusRef}>
                <hr className='featurette-divider'/>
                <div className="row featurette">
                    {!allMode && (
                        <div className='right-align'>
                            <h2><a className='no-line-href margin-right-3vh fold-btn' href='#' onClick={goToSummartDefault}>🔺접기</a></h2>
                        </div>
                    )}
                    <div className="col-md-7" dangerouslySetInnerHTML={{__html: selfInfoInfo?.content}}/>
                    {/*</div>*/}
                    <div className="col-md-5">
                        <img
                            src={myCharacterImg}
                            alt="selfIntro-image"
                            className="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto"
                            width="500"
                            height="500"
                        />
                    </div>
                </div>
            </div>
        </>
    )
}


export default SelfIntroduction;